import { FolderSpecialOutlined } from "@mui/icons-material";

const specialSkillResource = {
    title: "Special Skills and Hobbies",
    singular: "Special Skill",

    collectionField: "specialSkills",

    displayField: "skillStyle",
    icon: FolderSpecialOutlined,

    columns: [
        {
            field: "description",
            header: "Special Skills and Hobbies",
            type: "text"
        }
    ],

    fields: {
        skillStyle: {
            name: "skillStyle",
            label: "Skill",
            type: "text"
        },
        description: {
            name: "description",
            label: "Special Skills and Hobbies",
            type: "textarea",
            required: true
        }
    }
};

export default specialSkillResource;
